document.querySelectorAll('.ds-product-form').forEach((form) => {
  const panel = form.querySelector('.ds-addons');
  if (!panel || form.dataset.addonsReady) return;
  form.dataset.addonsReady = 'true';
  form.addEventListener('submit', async (event) => {
    const selected = [...panel.querySelectorAll('[data-addon]:checked')];
    if (!selected.length) return;
    event.preventDefault();
    if (form.dataset.adding === 'true') return;
    const source = new FormData(form);
    const body = new FormData();
    body.append('items[0][id]', source.get('id'));
    body.append('items[0][quantity]', source.get('quantity') || '1');
    for (const [key, value] of source.entries()) {
      if (key.startsWith('properties[') && (!(value instanceof File) || value.size)) body.append('items[0][' + key.replace('[', ']['), value);
      if (key === 'selling_plan') body.append('items[0][selling_plan]', value);
    }
    selected.forEach((choice, index) => {
      const id = choice.dataset.addon === 'picks' ? panel.querySelector('[data-addon-pick-variant]').value : choice.dataset.variant;
      body.append(`items[${index + 1}][id]`, id);
      body.append(`items[${index + 1}][quantity]`, '1');
    });
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    const error = panel.querySelector('[role="alert"]');
    error.hidden = true;
    buttons.forEach(button => button.disabled = true);
    form.dataset.adding = 'true';
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method: 'POST', body});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || error.dataset.error);
      window.location.assign(window.Shopify.routes.root + 'cart');
    } catch (failure) {
      error.textContent = failure.message || error.dataset.error;
      error.hidden = false;
      buttons.forEach(button => button.disabled = false);
      form.dataset.adding = 'false';
    }
  });
});
